import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Collapse, Group, List, Text, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconHelp } from '@tabler/icons-react';
import { useUserStore } from '../../store/userStore';
import { useDismissHint } from '../../hooks/useOnboardingApi';

const HINT_ID = 'essays-guide';
const ITEM_KEYS = ['done', 'flat', 'empty', 'autosave'] as const;

/**
 * Памятка по заполнению эссе. Раскрыта, пока человек её не свернёт; свёрнутая
 * остаётся строкой-переключателем, а не исчезает совсем — иначе вспомнить, что
 * делают плюсики, будет негде.
 */
export const EssayGuide: React.FC = () => {
  const { t } = useTranslation();
  const user = useUserStore((s) => s.user);
  const dismissHint = useDismissHint();
  const isDismissed = user?.onboardingState?.dismissedHints?.includes(HINT_ID) === true;
  const [isOpen, setIsOpen] = useState(!isDismissed);

  const toggle = () => {
    // Первое сворачивание запоминаем: в следующем месяце памятка откроется свёрнутой.
    if (isOpen && !isDismissed) dismissHint.mutate(HINT_ID);
    setIsOpen((prev) => !prev);
  };

  return (
    <Card withBorder radius="md" padding="sm">
      <UnstyledButton onClick={toggle} aria-expanded={isOpen} w="100%">
        <Group gap="xs" wrap="nowrap">
          <ThemeIcon variant="light" color="teal" size="sm" radius="sm">
            <IconHelp size={14} />
          </ThemeIcon>
          <Text size="sm" fw={600} style={{ flex: 1 }}>
            {t('essays.guide.title')}
          </Text>
          <IconChevronDown
            size={16}
            stroke={1.5}
            style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 150ms' }}
          />
        </Group>
      </UnstyledButton>
      <Collapse in={isOpen}>
        <List size="sm" spacing={6} mt="sm" c="dimmed">
          {ITEM_KEYS.map((key) => (
            <List.Item key={key}>{t(`essays.guide.items.${key}`)}</List.Item>
          ))}
        </List>
      </Collapse>
    </Card>
  );
};
